import { Component, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-listcustomer',
  templateUrl: './listcustomer.component.html',
  styleUrls: ['./listcustomer.component.scss'],
})
export class ListCustomerComponent implements OnInit, OnDestroy {
  customerList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  public isCollapsed = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'Code', field: 'code', filter: true },
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Customer Type', field: 'customertype' },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: { value: boolean; }) => {
        // console.log(params);
        let statusHtml = '<span class="badge bg-dark">Not Active</span>';
        if (params.value) {
          statusHtml = '<span class="badge badge-pill bg-success">Active</span>';
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];
  rowData = [];
  selectedSCId: number;

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private customerService: CustomerService,
    private titleService: Title
  ) {
    titleService.setTitle('Customers');
    this.context = { componentParent: this, componentName: 'ListCustomerComponent', actionConfig: { delete: true, edit: true, inboundAction: true, showReceipt: true }};
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(val => {
        if (val !== null) {
          this.selectedSCId = val;
          this.bindCustomerList(this.selectedSCId, true);
        }
      });
    }
  }

  ReceiptAction(cell: any) {
    // console.log('cell',cell.id);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate([`setup/customers/${cell.id}/contract`]);
      }
    } catch (e) {
      console.error(e);
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Customers');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindCustomerList(servicecenterid: number,refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.customerService.GetAllList({scid: servicecenterid,refresh: refresh}).subscribe((res: any) => {
        if (res && res.success) {
          // console.log(res);
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else if ((res && !res.success)){
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/setup/customers/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    try {
      if (!this.permConfig.isDeleteAllowed) {
        this.warningDialog('No access to Delete.');
      }
      else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
        this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.customerService.Delete(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record deleted successfuly','Success','success');
            this.bindCustomerList(this.selectedSCId, true);
          } else if(res && !res.success){
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message,'Cannot delete !','error')
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }


  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);
    }

  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}
